//header fixed
$(".wd-product-page-header-handle").click(function () {
  if ($(this).hasClass("wd-product-page-header-handle-active")) {
    $(this).removeClass("wd-product-page-header-handle-active");
    $(this).addClass("wd-product-page-header-handle-active2");
    $(this).siblings(".wd-product-page-header-handle-menu").slideUp();
  } else {
    $(this).removeClass("wd-product-page-header-handle-active2");
    $(this).addClass("wd-product-page-header-handle-active");
    $(this).siblings(".wd-product-page-header-handle-menu").slideDown();
  }
});
$(document).scroll(function () {
  var scroH = $(document).scrollTop();
  var header = $(".wd-product-page-content").offset().top;
  if (scroH >= header) {
    $(".wd-product-page-header").css("position", "fixed");
    $(".wd-product-page-header").css("z-index", "3");
  } else {
    $(".wd-product-page-header").css("position", "absolute");
    $(".wd-product-page-header").css("z-index", "1");
  }
});
//banner video show
$(".wd-product-page-banner-video").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "https://www.youtube.com/embed/Em1UiaOk03I");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show")
    .fadeIn(200);
  $(this).parents("html").css("overflow", "hidden");
});
$(".wd-product-page-banner-video-show-btn").click(function () {
  $(this).parents(".wd-product-page-banner-video-show").fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "");
  $(this).parents("html").css("overflow", "auto");
});
$(".wd-product-page-banner-video-show").click(function () {
  $(this).fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "");
  $(this).parents("html").css("overflow", "auto");
});

//NSF hover btn
$(".wd-product-page-hover-btn").mouseenter(function () {
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation",
    "animation-top-enter 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation",
    "animation-bottom-enter 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation-fill-mode",
    "forwards"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation-fill-mode",
    "forwards"
  );
});
$(".wd-product-page-hover-btn").mouseleave(function () {
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation",
    "animation-top-leave 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation",
    "animation-bottom-leave 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation-fill-mode",
    "forwards"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation-fill-mode",
    "forwards"
  );
});

//hover animation
$(".wd-product-page-more_pure-animation2").mouseenter(function () {
  $(this)
    .find(".wd-product-page-more_pure-animation2-content-circle-box")
    .css("animation", "box-animation 0.8s");
  $(this)
    .find(".wd-product-page-more_pure-animation2-content-circle-box")
    .css("animation-fill-mode", "forwards");
});

//click choose card
$(".wd-product-page-header-title").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-spe").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeIn();
  $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-spe").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-faq").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-faq").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeIn();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

//faq click show
$(".wd-product-page-faq-content-q").click(function () {
  if (
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .css("display") == "none"
  ) {
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideUp();
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-q-minus")
      .css("display", "none");
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-q-add")
      .css("display", "block");

    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideDown();
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .css("display", "flex");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .css("display", "none");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .eq(1)
      .css("display", "block");
  } else {
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideUp();
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .css("display", "none");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .eq(0)
      .css("display", "block");
  }
});

var swiper = new Swiper(".wd-product-page-reviews-swiper", {
  autoplay: true,
  loop: true,
  effect: "fade",
  navigation: {
    nextEl: ".wd-product-page-reviews-swiper-button-next",
    prevEl: ".wd-product-page-reviews-swiper-button-prev",
  },
});

var more_pure_swiper = new Swiper(
  ".wd-product-page-more_pure-animation-mobile-swiper",
  {
    pagination: {
      el: ".wd-product-page-more_pure-animation-progress-line",
      type: "progressbar",
    },
    on: {
      progress: function (swiper, progress) {
        if (progress == 0.5) {
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation",
            "box-animation 0.8s"
          );
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation-fill-mode",
            "forwards"
          );
        } else {
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation",
            "none"
          );
          $(".wd-product-page-more_pure-animation2-content-circle-box").css(
            "animation-fill-mode",
            "forwards"
          );
        }
      },
    },
  }
);

var more_efficient_swiper = new Swiper(
  ".wd-product-page-more_efficient-animation-swiper",
  {
    pagination: {
      el: ".wd-product-page-more_pure-more_efficient-progress-line",
      type: "progressbar",
    },
  }
);

var more_family_swiper = new Swiper(
  ".wd-product-page-family-animation-mobile-swiper",
  {
    pagination: {
      el: ".wd-product-page-family-animation-progress-line",
      type: "progressbar",
    },
  }
);

// banner GSAP
gsap.registerPlugin(ScrollTrigger);
// ScrollTrigger.normalizeScroll(true);
ScrollTrigger.config({ ignoreMobileResize: true });

var window_width = $(window).width();
// if (window_width >= 768) {
//   let tl_banner = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-banner",
//       y: () => {
//         innerHeight;
//       },
//       pin: true,
//       start: "top top",
//       end: innerHeight * 2,
//       scrub: 0,
//     },
//   });
//   tl_banner
//     .to(
//       ".wd-product-page-banner-content",
//       {
//         top: "5%",
//         autoAlpha: "0",
//         duration: "0.5",
//       },
//       0.1
//     )
//     .to(
//       ".wd-product-page-banner-feature",
//       {
//         top: "calc(50% - 167px)",
//         autoAlpha: "1",
//         duration: "0.5",
//       },
//       0.1
//     );
// } else {
//   let tl1 = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-banner",
//       y: () => {
//         innerHeight;
//       },
//       pin: true,
//       start: "top top",
//       end: innerHeight * 3,
//       scrub: 0,
//     },
//   });
//   tl1
//     .to(
//       ".wd-product-page-banner-content",
//       {
//         top: "5%",
//         autoAlpha: "0",
//         duration: "0.5",
//       },
//       0.1
//     )
//     .to(
//       ".wd-product-page-banner-feature",
//       {
//         top: "calc(50% - 242px)",
//         autoAlpha: "1",
//         duration: "0.5",
//       },
//       0.1
//     );
// }

// featured animation
$(document).scroll(function () {
  var featured_height = $(".wd-product-page-featured").height();
  var featured_scroll_height = $(".wd-product-page-featured").offset().top;
  var H_scroll = $(document).scrollTop();
  var window_height = $(window).height();
  if (H_scroll > featured_scroll_height - 500) {
    $(".wd-product-page-featured-item-svg").css("transform", "translateY(0px)");
    $(".wd-product-page-featured-item-des").css("transform", "translateY(0px)");
    $(".wd-product-page-featured-item-des").css("opacity", "1");
  }
});

// more pure GSAP
// if (window_width >= 1221) {
//   let tl_more_pure = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-more_pure",
//       pin: true,
//       scrub: 1,
//       start: "top top",
//       pinSpacing: true,
//       once: false,
//       duration: 1,
//     },
//   });
//   tl_more_pure
//     .to(".wd-product-page-more_pure-media", {
//       duration: 0.5,
//       scale: 0.5,
//     })
//     .to(".wd-product-page-more_pure-info", {
//       top: "calc(55vh + 50px)",
//       opacity: 1,
//       duration: 0.5,
//     })
//     .to(".wd-product-page-more_pure-btn", {
//       opacity: 1,
//       x: 0,
//     });
// } else if (window_width >= 768) {
//   let tl_more_pure = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-more_pure",
//       pin: true,
//       scrub: 1,
//       start: "top top",
//       pinSpacing: true,
//       once: false,
//       duration: 1,
//     },
//   });
//   tl_more_pure
//     .to(".wd-product-page-more_pure-media video", {
//       duration: 0.5,
//       height: "65vh",
//     })
//     .to(".wd-product-page-more_pure-info", {
//       bottom: "5%",
//       opacity: 1,
//       duration: 0.5,
//     })
//     .to(".wd-product-page-more_pure-btn", {
//       opacity: 1,
//       x: 0,
//     });
// } else {
//   let tl_more_pure = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-more_pure",
//       pin: true,
//       scrub: 1,
//       start: "top",
//       pinSpacing: true,
//       once: false,
//       duration: 1,
//     },
//   });
//   tl_more_pure
//     .to(".wd-product-page-more_pure-media video", {
//       duration: 0.5,
//       height: "59vh",
//     })
//     .to(".wd-product-page-more_pure-info", {
//       bottom: "5%",
//       opacity: 1,
//       duration: 0.5,
//     })
//     .to(".wd-product-page-more_pure-btn", {
//       opacity: 1,
//       x: 0,
//     });
// }

// More Efficient GSAP
// let tl_more_efficient = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".wd-product-page-more_efficient",
//     pin: true,
//     scrub: 1,
//     start: "bottom bottom",
//     pinSpacing: true,
//     once: false,
//     duration: 0.5,
//   },
// });
// tl_more_efficient.to(".wd-product-page-more_efficient-content-btn", {
//   x: 0,
//   opacity: 1,
//   duration: 0.5,
// });

// More Convenient GSAP
// let tl_more_convenient = gsap.timeline({
//   scrollTrigger: {
//     trigger: ".wd-product-page-more_convenient",
//     pin: true,
//     scrub: 1,
//     start: "top top",
//     pinSpacing: true,
//     once: false,
//     duration: 1,
//   },
// });
// tl_more_convenient
//   .to(".wd-product-page-more_convenient-content1", {
//     y: 0,
//     duration: 0.5,
//   })
//   .to(".wd-product-page-more_convenient-content2", {
//     y: 0,
//     opacity: 1,
//     duration: 0.5,
//   });

// more Secure GSAP
// if (window_width >= 1221) {
//   let tl_more_secure = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-family",
//       pin: true,
//       scrub: 1,
//       start: "top top",
//       pinSpacing: true,
//       once: false,
//       duration: 1,
//     },
//   });
//   tl_more_secure
//     .to(".wd-product-page-family-info img", {
//       duration: 0.5,
//       scale: 0.5,
//     })
//     .to(".wd-product-page-family-content", {
//       top: "calc(55vh + 50px)",
//       opacity: 1,
//       duration: 0.5,
//     })
//     .to(".wd-product-page-family-btn", {
//       opacity: 1,
//       x: 0,
//     });
// } else if (window_width >= 768) {
//   let tl_more_secure = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-family",
//       pin: true,
//       scrub: 1,
//       start: "top top",
//       pinSpacing: true,
//       once: false,
//       duration: 1,
//     },
//   });
//   tl_more_secure
//     .to(".wd-product-page-family-info img", {
//       duration: 0.5,
//       height: "65vh",
//     })
//     .to(".wd-product-page-family-content", {
//       bottom: "5%",
//       opacity: 1,
//       duration: 0.5,
//     })
//     .to(".wd-product-page-family-btn", {
//       opacity: 1,
//       x: 0,
//     });
// } else {
//   let tl_more_secure = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".wd-product-page-family",
//       pin: true,
//       scrub: 1,
//       start: "top",
//       pinSpacing: true,
//       once: false,
//       duration: 1,
//     },
//   });
//   tl_more_secure
//     .to(".wd-product-page-family-content", {
//       bottom: "10%",
//       opacity: 1,
//       duration: 0.5,
//     })
//     .to(".wd-product-page-family-btn", {
//       opacity: 1,
//       x: 0,
//     });
// }

var sections_more_pure = gsap.utils.toArray(
  ".wd-product-page-more_pure-animation-item"
);
var sections_more_efficient = gsap.utils.toArray(
  ".wd-product-page-more_efficient-animation-item"
);
var sections_more_secure = gsap.utils.toArray(
  ".wd-product-page-family-animation-item"
);

var tl_more_pure_animation;
var tl_more_efficient_animation;
var tl_family_animation;
var H_scroll;
var click_H_scroll;

$(document).scroll(function () {
  H_scroll = $(document).scrollTop();
});

// more pure
$(".wd-product-page-more_pure-btn").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .css({ left: "-100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-content")
    .siblings(".wd-product-page-more_pure-animation-content")
    .css({ display: "block", left: "0", "z-index": "999" });
  if (window_width > 1220) {
    $("body").css("height", "200vh");
  } else {
    $("body").css("height", "100vh");
    more_pure_swiper.slideTo(0,0,false)
  }

  var more_pure_scroll_width = 0.65 * window_width;
  click_H_scroll = H_scroll;

  $(window).scrollTop(0);

  tl_more_pure_animation = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".wd-product-page-more_pure-animation",
        // pin: true,
        start: "top top",
        end: innerHeight,
        scrub: 0,
        onUpdate: (self) => {
          var progress = self.progress * 300;
          var progress_now = document.getElementsByClassName(
            "wd-product-page-more_pure-animation-progress-line-now"
          )[0];
          progress_now.style.width = progress + "px";
        },
      },
    })
    .to(sections_more_pure, {
      x: "-" + more_pure_scroll_width,
    });
});
$(".wd-product-page-more_pure-animation-progress-svg").click(function () {
  $(this)
    .parents(".wd-product-page-more_pure-animation-content")
    .css({ left: "100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-more_pure-animation-content")
    .siblings(".wd-product-page-content")
    .css({ left: "0", "z-index": "2", display: "block" });
  $("body").css("height", "auto");
  tl_more_pure_animation = null;
  $("html").scrollTop(click_H_scroll);
});

// more Efficient
$(".wd-product-page-more_efficient-content-btn").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .css({ left: "-100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-content")
    .siblings(".wd-product-page-more_efficient-animation-content")
    .css({ display: "block", left: "0", "z-index": "999" });
  if (window_width > 1220) {
    $("body").css("height", "200vh");
  } else {
    $("body").css("height", "100vh");
    more_efficient_swiper.slideTo(0,0,false)
  }
  var more_efficient_scroll_width = 1.03 * window_width;
  click_H_scroll = H_scroll;

  $(window).scrollTop(0);

  tl_more_efficient_animation = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".wd-product-page-more_efficient-animation",
        start: "top top",
        // y:()=>{
        //   innerHeight
        // },
        end: innerHeight,
        scrub: 0,
        onUpdate: (self) => {
          var progress = self.progress * 300;
          var progress_now = document.getElementsByClassName(
            "wd-product-page-more_efficient-progress-line-now"
          )[0];
          progress_now.style.width = progress + "px";
        },
      },
    })
    .to(sections_more_efficient, {
      x: "-" + more_efficient_scroll_width,
      ease: "none",
    });
});
$(".wd-product-page-more_efficient-progress-svg").click(function () {
  $(this)
    .parents(".wd-product-page-more_efficient-animation-content")
    .css({ left: "100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-more_efficient-animation-content")
    .siblings(".wd-product-page-content")
    .css({ left: "0", "z-index": "2", display: "block" });

  // tl_more_efficient_animation.kill();
  $("body").css("height", "auto");
  tl_more_efficient_animation = null;
  $("html").scrollTop(click_H_scroll);
});

// more secure //family
$(".wd-product-page-family-btn-content").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .css({ left: "-100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-content")
    .siblings(".wd-product-page-family-animation-content")
    .css({ display: "block", left: "0", "z-index": "999" });
  if (window_width > 1220) {
    $("body").css("height", "200vh");
  } else {
    $("body").css("height", "100vh");
    more_family_swiper.slideTo(0,0,false)
  }
  var family_scroll_width = 2.125 * window_width;
  click_H_scroll = H_scroll;

  $(window).scrollTop(0);

  tl_family_animation = gsap
    .timeline({
      scrollTrigger: {
        trigger: ".wd-product-page-family-animation",
        // pin: true,
        start: "top top",
        // y:()=>{
        //   innerHeight
        // },
        end: innerHeight,
        scrub: 0,
        onUpdate: (self) => {
          var progress = self.progress * 300;
          var progress_now = document.getElementsByClassName(
            "wd-product-page-family-animation-progress-line-now"
          )[0];
          progress_now.style.width = progress + "px";
        },
      },
    })
    .to(sections_more_secure, {
      x: "-" + family_scroll_width,
      ease: "none",
    });
});
$(".wd-product-page-family-animation-progress-svg").click(function () {
  $(this)
    .parents(".wd-product-page-family-animation-content")
    .css({ left: "100%", "z-index": "1", display: "none" });
  $(this)
    .parents(".wd-product-page-family-animation-content")
    .siblings(".wd-product-page-content")
    .css({ left: "0", "z-index": "2", display: "block" });

  // tl_family_animation.kill();
  $("body").css("height", "auto");
  tl_family_animation = null;
  $("html").scrollTop(click_H_scroll);
});

// movie start
$(document).ready(function () {
  $(".wd-product-page-more_pure").mouseenter(function () {
    $(this).find("video").get(0).play();
  });
  if (window_width >= 768) {
    $(".wd-product-page-more_convenient").mouseenter(
      function () {
        $(this).find("video").get(0).play();
      }
    );
  } else {
    $(".wd-product-page-more_convenient").mouseenter(
      function () {
        $(this).find("video").eq(1).get(0).play();
      }
    );
  }
  $(".wd-product-page-filter_replacement").mouseenter(function () {
    $(this).find("video").get(0).play();
  });

})
  
